import React from "react";
import ProjectHealthFieldProto from "./project-health-proto";

export default function renderProjectHealthInList(props) {
    return <ProjectHealthFieldProto renderMode="list" {...props} />;
}